<template>
  <div ref="notificationModal" id="notificationModal" class="modal modal-v modal-v--normal fade show" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
        <div class="modal-body mt-3 mb-4" v-if="notification.type==='App\\Notifications\\Admin\\SendUserInformation'">
          <div v-if="notification.data" class="d-flex flex-column align-items-center justify-content-start justify-content-md-center text-center">
            <div v-if="notification.data.category === 'info'"><img class="profile-show__modal-image mt-3" src="/img/viluu/background/message_icon.png" alt="alert-icon"></div>
            <div v-if="notification.data.category === 'warning'"><img class="profile-show__modal-image mt-3" src="/img/viluu/background/alert_icon.png" alt="coins-icon"></div>
            <h2 class="title title--medium mt-4">{{ notification.data.title || trans.get('profile:modal.admin_message') }} </h2>
            <p class="desc desc--medium desc--grey my-3"> " {{ notification.data.message }} " </p>
          </div>
        </div>
        <div v-else-if="isBaseModal || isPopupModal" class="modal-body mt-3 mb-4">
          <div class="d-flex flex-column align-items-center justify-content-start justify-content-md-center text-center">
            <h2 v-if="notification.data.header" class="title title--medium mb-1">
              {{ notification.data.header }}
            </h2>

            <p v-if="notification.data.slogan" class="title title--small title--lightgrey mb-3">
              {{ notification.data.slogan }}
            </p>

            <p v-if="notification.data.top_text" class="desc desc--lightgrey">
              {{ notification.data.top_text }}
            </p>

            <div v-if="notification.data.picture">
              <img class="profile-show__modal-image mt-3" :src="notification.data.picture" alt="alert-icon">
            </div>

            <div v-if="notification.data.picture_url">
              <img class="profile-show__modal-image mt-3" :src="notification.data.picture_url" alt="alert-icon">
            </div>

            <p v-if="notification.data.bottom_text" class="desc desc--lightgrey mt-2">
              {{ notification.data.bottom_text }}
            </p>

            <div v-if="isBaseModal && notification.data.button_text">
              <a v-if="notification.data.button_web_link" class="button button__fill my-3" :href="notification.data.button_web_link">{{ notification.data.button_text }}</a>
              <a v-else data-dismiss="modal" aria-label="Close" class="button button__fill my-3">{{ notification.data.button_text }}</a>
            </div>

            <div v-if="isPopupModal && notification.data.button_text">
              <a v-if="notification.data.button_web_link" @click.prevent="callPost" class="button button__fill my-3" href="#">{{ notification.data.button_text }}</a>
              <a v-else data-dismiss="modal" aria-label="Close" class="button button__fill my-3">{{ notification.data.button_text }}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotificationModal',
  props: {
    isBaseModal: Boolean,
    isPopupModal: Boolean,
    notification: Object,
  },
  data() {
    return {
      openedAt: null,
      successResponse: false,
      click: {},
      clickEventListener: {},
    };
  },
  watch: {},
  methods: {
    open() {
      $(this.$refs.notificationModal).modal('show');
    },
    close() {
      $(this.$refs.notificationModal).modal('hide');

      this.sendLog();

      setTimeout(() => {
        this.$emit('close', this.notification);
      }, 1);
    },
    callPost() {
      let vm = this;
      axios
        .post(this.notification.data.button_web_link)
        .then(response => {
          this.successResponse = true;
          vm.close();
        })
        .catch(error => {
          if (error.response.data.reason) {
            vm.close();
          }
        });
    },
    sendLog() {
      if (this.successResponse === true) {
        return;
      }

      if (this.notification.type !== 'daily_reward') {
        return;
      }

      axios
        .post(zRoute('ajax.user.event_tracking'), {
          'type': 'MissClick',
          'event': this.notification.type,
          'time': (Date.now() - this.openedAt) / 1000,
          'click_co': `${this.click.clientX}px:${this.click.clientY}px`,
          'window': `${this.click.innerWidth}px:${this.click.innerHeight}px`,
        })
        .catch(error => {
          console.error(error);
        });
    },
    handleClick(event) {
      this.click = {
        innerWidth: window.innerWidth,
        innerHeight: window.innerHeight,
        clientX: event.clientX,
        clientY: event.clientY,
      };
    }
  },
  mounted() {
    this.open();
    this.openedAt = Date.now();

    document.addEventListener('click', this.handleClick);

    $(this.$refs.notificationModal)
      .on('hidden.bs.modal', () => {
        this.close();
      });
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClick);
  }
};
</script>

<style scoped>

</style>
